module.exports = __webpack_public_path__ + "assets/analytics_marker-Hiighest.ff09d95a.svg";